var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('AddProjectDialog',{attrs:{"edit-data":_vm.editData,"label-width":_vm.labelWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }